export default __webpack_public_path__ + "static/media/icon-triangle.bfdfc1b7.svg";